"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var parseProductDescription = function parseProductDescription(text) {
  if (!text) return "";
  var textContainsNewLineChar = text.includes("\n");
  var parsedDescription = "";
  if (!textContainsNewLineChar) {
    return text;
  } else {
    if (text.includes("<br>") || text.includes("<h2>")) {
      parsedDescription = text.replace(/\n/gi, "");
    } else {
      parsedDescription = text.replace(/\n/gi, "<br />");
    }
  }
  return parsedDescription;
};
var _default = parseProductDescription;
exports["default"] = _default;